<div class="wrapper">
    <div class="maxwidth">
        <h4 class="title tipo-second-color bold">{{"PRIVATE.HELP-INFORMATION.TITLE" | translate}}</h4>

        <div class="video-grid">
            @for (v of videos; track v.id) {
                <div class="video">
                    <img src="../../../assets/img/private/video.jpg"
                        [alt]="v.alt"
                        class="item"
                        (click)="openVideo(v.id)"/>
                        <h2 class="text_video tipo-second-color bold">{{v.title}}</h2>
                    <p class="regular">{{v.caption}}</p>
                </div>
            }
        </div>

        @if (isModalOpen) {
            <div class="modal-overlay" (click)="closeModal()">
                <div class="modal-content" (click)="$event.stopPropagation()">
                    <button (click)="closeModal()" class="button_icon">
                        <fa-icon [icon]="faXmark" class="icon"></fa-icon>
                    </button>
                    @if (currentVideoUrl) {
                        <iframe
                            [src]="currentVideoUrl"
                            frameborder="0"
                            allow="autoplay"
                            allowfullscreen
                        ></iframe>
                    }
                </div>
            </div>
        }
    </div>
</div>
